export enum CATEGORY {
  CASE = 'case',
  EVENT = 'event',
  FOCUS = 'focus',
  INNER_PAGE = 'inner-page',
  INTERVIEW = 'interview',
  KEYS_FIGURES = 'keys-figures',
  LIFESPIRATION = 'lifespiration',
  MISCONCEPTION = 'misconception',
  POINT_OF_VIEW = 'point-of-view',
  PORTRAIT = 'portrait',
  SERVICES = 'services',
  PUBLICATION = 'publication',
  PUBLICATION_DOWNLOADABLE = 'publication-downloadable',
  RIGHT_NOW = 'right-now',
}
